import { Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { Injectable, Injector } from '@angular/core';
import { LogedInUserInfo } from '../@models/logedin-user-info.model';
import { TaskService } from '../@services/task.service';

export type UserSettingsModel = Partial<LogedInUserInfo>;

@State<UserSettingsModel>({
  name: 'userSettings',
  defaults: {}
})
@Injectable()
export class UserSettingsState {
  private static taskService: TaskService;

  constructor(injector: Injector) {
    UserSettingsState.taskService = injector.get(TaskService);
  }

  @Selector()
  static settings(state: UserSettingsModel): UserSettingsModel {
    return state;
  }

  @Selector()
  static dateTimeFormat(state: UserSettingsModel): string | undefined {
    return state.dateTimeFormat;
  }

  @Receiver()
  static load({ setState }: StateContext<UserSettingsModel>): void {
    UserSettingsState.taskService.getLogedInUserInfo().subscribe({
      next: (info: LogedInUserInfo) => {
        if (info) {
          setState(info);
        }
      },
      error: (err) => {
        console.warn('[UserSettingsState] Failed to load user settings:', err);
      }
    });
  }
}
